<template>
    <form action="#" class="form form-search flex-column" :class="{ 'filters-visible': isFiltersVisible}">
        <div class="field mb-3">
            <label class="label mb-4px" for="uxoType">Category</label>
            <div class="control">
                <select id="uxoType" class="select" v-model="form.category">
                    <option value="">Select category</option>
                    <option v-for="(category, index) in categories" :value="category.id">{{category.name}}
                    </option>
                </select>
            </div>
        </div>
        <div class="field mb-3">
            <label class="label mb-4px" for="countryOfOrigin">Country of Origin</label>
            <div class="control">
                <select id="countryOfOrigin" class="select" v-model="form.countryOfOrigin">
                    <option value="">Select a country</option>
                    <option v-for="(country, index) in countriesOfOrigin" :value="country.id">{{country.name}}
                    </option>
                </select>
            </div>
        </div>
        <div class="field mb-3">
            <label class="label mb-4px" for="countryOfUse">Country found in</label>
            <div class="control">
                <select id="countryOfUse" class="select" v-model="form.countryOfUse">
                    <option value="">Select a country</option>
                    <option v-for="(country, index) in countriesOfUse" :value="country.id">{{country.name}}
                    </option>
                </select>
            </div>
        </div>
        <div class="dimensions mb-3">
            <label class="label lh-lg mb-1">Dimensions</label>
            <div class="d-flex justify-content-between">
                <div class="field w-50 mr-2">
                    <label class="label d-none" for="width">Width</label>
                    <div class="control">
                        <input id="width" class="input" type="text" placeholder="W" v-model="form.width">
                    </div>
                </div>
                <div class="field w-50 mr-2">
                    <label class="label d-none" for="height">Height</label>
                    <div class="control">
                        <input id="height" class="input" type="text" placeholder="H" v-model="form.height">
                    </div>
                </div>
                <div class="field">
                    <label class="label d-none" for="dimensionUnit">Unit</label>
                    <div class="control">
                        <div class="font-weight-bold t-navy">
                            <select id="dimensionUnit" class="unit select" v-model="form.dimensionUnit">
                                <option value="mt" selected>mm</option>
                                <option value="il">in</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="weight mb-2">
            <label class="label lh-lg mb-1">Weight</label>
            <div class="d-flex justify-content-between">
                <div class="field w-100 mr-2">
                    <label class="label d-none" for="weight">Weight</label>
                    <div class="control">
                        <input id="weight" class="input" type="text" placeholder="Enter weight" v-model="form.weight">
                    </div>
                </div>
                <div class="field">
                    <label class="label d-none" for="weightUnit">Unit</label>
                    <div class="control">
                        <select id="weightUnit" class="unit select " v-model="form.weightUnit">
                            <option value="mt" selected>kg</option>
                            <option value="il">lbs</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
        <input type="hidden" v-model="form.query" />
        <a class="reset-filters d-flex fs-14 t-navy font-weight-light lh-lg text-underline mb-4" @click="resetFilters">
            Reset Filters</a>
        <button @click="hideSearchFilters" class="hamburger hamburger--slider is-active p-3 mr-0" type="button">
              <span class="hamburger-box">
                <span class="hamburger-inner"></span>
              </span>
        </button>
        <button class="btn btn-filter" @click.prevent="search()">View Results</button>
    </form>
</template>

<script>
    import axios from 'axios';
    import {mapActions, mapState} from "vuex";

    export default {
        name: 'CatUxoSearchFilters',
        props: {
            query: {
                type: String,
                default: ''
            }
        },
        data: function () {
            return {
                form: {
                    query: this.query,
                    category: '',
                    countryOfOrigin: '',
                    countryOfUse: '',
                    width: '',
                    height: '',
                    dimensionUnit: 'mt',
                    weight: '',
                    weightUnit: 'mt'

                },
                isFiltersVisible: false
            }
        },
        watch: {
            form: {
                deep: true,
                handler: _.debounce(function(val) {
                    this.setFilters(val);
                    this.fetchHazards({page: this.page ? this.page : 1, filters: val});
                }, 500)
            },
            uxoType(val) {
            },
        },
        methods: {
            ...mapActions('hazards', [
                'fetchUxoType',
                'fetchHazards',
            ]),
            ...mapActions('search', [
               'setFilters'
            ]),
            search() {
                this.fetchHazards({page: this.page ? this.page : 1, filters: this.form});
                this.hideSearchFilters();
            },
            hideSearchFilters() {
                this.isFiltersVisible = false;

                let body = document.body;
                body.classList.remove('has-overlay');
            },
            resetFilters() {
                this.form.query = '';
                this.form.category = '';
                this.form.category = '';
                this.form.countryOfOrigin = '';
                this.form.countryOfUse = '';
                this.form.width = '';
                this.form.height = '';
                this.form.dimensionUnit = 'mt';
                this.form.weight = '';
                this.form.weightUnit = 'mt';
            },
        },
        computed: {
            ...mapState('hazards', [
                'hazards',
                'uxoType',
                'searchFilters'
            ]),
            ...mapState('search', [
               'filters'
            ]),
            categories: function () {
                let categories = [];
                if (!this.searchFilters.categories) return categories;

                this.searchFilters.categories.forEach((filter) => {
                    if (categories.findIndex(category => category.id === filter.id) === -1) {
                        categories.push(filter);
                    }
                });

                return categories.sort((a, b) => a.name.localeCompare(b.name));

            },
            countriesOfOrigin: function () {
                let countries = [];
                if (!this.searchFilters.countriesOfOrigin) return countries;

                this.searchFilters.countriesOfOrigin.forEach((filter) => {
                    if (countries.findIndex(country => country.id === filter.id) === -1) {
                        countries.push(filter);
                    }
                });

                return countries.sort((a, b) => a.name.localeCompare(b.name));
            },
            countriesOfUse: function () {
                let countries = [];
                if (!this.searchFilters.countriesOfUse) return countries;

                this.searchFilters.countriesOfUse.forEach((filter) => {
                    if (countries.findIndex(country => country.id === filter.id) === -1) {
                        countries.push(filter);
                    }
                });

                return countries.sort((a, b) => a.name.localeCompare(b.name));
            },
        },
        mounted() {
            let $this = this;

            $this.$root.$on('showSearchFilters', () => {
                $this.isFiltersVisible = true;
            })
        }
    }
</script>

<style lang="scss" scoped>
    @media(max-width: map-get($grid-breakpoints, "md")) {
        .form-search {
            display: none;
        }

        .filters-visible {
            &.form-search {
                display: flex;
                position: fixed;
                top: 0;
                left: 0;
                background: $c-white;
                z-index: 999;
                width: 100%;
                height: 100%;
                padding: rem(64px 16px 16px 16px);
            }

            .reset-filters {
                position: absolute;
                left: 0;
                top: 0;
                padding: rem(16px);
            }

            .hamburger {
                position: absolute;
                top: 0;
                right: 0;
            }

            .btn-filter {
                position: fixed;
                width: 100%;
                bottom: 0;
                left: 0;
                border-radius: 0;
            }
        }
    }

    @media(min-width: 768px) {
        .form-search {
            display: flex;
        }

        .hamburger,
        .btn-filter {
            display: none;
        }
    }
</style>



// WEBPACK FOOTER //
// resources/js/components/SearchFilters.vue